"use client";

import { useProductTileContainerRef } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContainerRefContextProvider";
import { useContainerRef } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/useContainerRef";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";

/**
 * This helper enable us to detect if user is hovering on image for the first time,
 * then the `hasHovered` became true and we can load those components, to avoid loading
 * all of them on initial load.
 * @returns
 */
const useHasHovered = (
  containerRef: React.RefObject<HTMLDivElement | null> | null
) => {
  const [hasHovered, setHasHovered] = useState(false);
  const refCurrent = useContainerRef(containerRef);

  useEffect(() => {
    const handleMouseEnter = () => setHasHovered(true);
    if (refCurrent) {
      refCurrent.addEventListener("mouseenter", handleMouseEnter, {
        once: true,
      });
      return () =>
        refCurrent.removeEventListener("mouseenter", handleMouseEnter);
    }
    return () => {};
  }, [refCurrent]);
  return hasHovered;
};

export const ComponentDisplayOnHoverContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isTabletAndAbove } = useViewport();

  const [isHovering, setisHovering] = useState(false);

  const containerRef = useProductTileContainerRef();
  const hasHovered = useHasHovered(containerRef);
  const refCurrent = useContainerRef(containerRef);

  const handleMouseEnter = () => setisHovering(true);
  const handleMouseLeave = () => setisHovering(false);
  useEffect(() => {
    if (refCurrent && isTabletAndAbove) {
      refCurrent.addEventListener("mouseover", handleMouseEnter);
      refCurrent.addEventListener("mouseout", handleMouseLeave);
      return () => {
        refCurrent.removeEventListener("mouseover", handleMouseEnter);
        refCurrent.removeEventListener("mouseout", handleMouseLeave);
      };
    }
    return () => {};
  }, [isTabletAndAbove, refCurrent]);

  if (!refCurrent || !hasHovered) {
    return null;
  }

  // TODO in the future we should not mount unless hovered, keeping as is to preserve existing functionality
  return (
    <VisibilityWrapper $isVisible={isHovering}>{children}</VisibilityWrapper>
  );
};

const VisibilityWrapper = styled.div<{ $isVisible: boolean }>`
  ${({ $isVisible }) =>
    !$isVisible
      ? css`
          display: none;
        `
      : ""}
`;
